/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';

import Avatar from 'components/Avatar';
import UserAvatar from 'users/components/UserAvatar';
import messageSenderAvatar from 'chat/queries/messageSenderAvatar.gql';

import type { OperationComponent } from 'react-apollo';

type InputProps = {
  uuid: string,
  avatarUrl?: ?string,
  senderType?: string,
};

const withData: OperationComponent<messageSenderAvatar, InputProps> = graphql(messageSenderAvatar, {
  options: ({ uuid }) => ({ variables: { uuid } }),
  skip: ({ senderType }) => senderType === 'EntitySender',
});

export default withData((props): ?React$Element<*> => {
  const { data, avatarUrl } = props;
  if (!data) {
    if (!avatarUrl) {
      console.error(
        'MessageSenderAvatarContainer - cannot render without avatarUrl if MessageSenderAvatarQuery is skipped'
      );
      return null;
    }
    return <Avatar {...props} image={avatarUrl} />;
  }

  if (data.loading) {
    return null;
  }
  if (data.error) {
    return <span>ERROR</span>;
  }

  const user = idx(data, _ => _.me.connectedUsers[0]);

  return <UserAvatar {...props} user={user} />;
});
